import Vue from 'vue';
import Voca from 'voca';

Vue.prototype.$voca = Voca;
